'use client';

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function CompanyIcon(props: SvgIconProps) {
	return (
		<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
			<path
				id="Vector"
				d="M4.76925 20.6C4.34742 20.6 3.98875 20.4522 3.69325 20.1567C3.39775 19.8611 3.25 19.5024 3.25 19.0807V8.61898C3.25 8.19731 3.39775 7.83873 3.69325 7.54323C3.98875 7.24773 4.34742 7.09998 4.76925 7.09998H7.25V4.61898C7.25 4.19731 7.39775 3.83873 7.69325 3.54323C7.98875 3.24773 8.34742 3.09998 8.76925 3.09998H15.2308C15.6526 3.09998 16.0113 3.24773 16.3068 3.54323C16.6023 3.83873 16.75 4.19731 16.75 4.61898V11.1H19.2308C19.6526 11.1 20.0113 11.2477 20.3068 11.5432C20.6023 11.8387 20.75 12.1973 20.75 12.619V19.0807C20.75 19.5024 20.6023 19.8611 20.3068 20.1567C20.0113 20.4522 19.6526 20.6 19.2308 20.6H13.25V16.6H10.75V20.6H4.76925ZM4.75 19.1H7.25V16.6H4.75V19.1ZM4.75 15.1H7.25V12.6H4.75V15.1ZM4.75 11.1H7.25V8.59998H4.75V11.1ZM8.75 15.1H11.25V12.6H8.75V15.1ZM8.75 11.1H11.25V8.59998H8.75V11.1ZM8.75 7.09998H11.25V4.59998H8.75V7.09998ZM12.75 15.1H15.25V12.6H12.75V15.1ZM12.75 11.1H15.25V8.59998H12.75V11.1ZM12.75 7.09998H15.25V4.59998H12.75V7.09998ZM16.75 19.1H19.25V16.6H16.75V19.1ZM16.75 15.1H19.25V12.6H16.75V15.1Z"
				fill="currentColor"
			/>
		</SvgIcon>
	);
}
